import { ResponsiveContainer, AreaChart, Area, Tooltip } from "recharts";

interface SparkLineProps {
  data: Array<{ date: string; count: number }>;
  color?: string;
  height?: number;
}

export function SparkLine({ data, color = "#fb7185", height = 40 }: SparkLineProps) {
  return (
    <div style={{ width: "100%", height }}>
      <ResponsiveContainer>
        <AreaChart data={data} margin={{ top: 4, right: 4, bottom: 0, left: 0 }}>
          <defs>
            <linearGradient id={`spark-${color}`} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={color} stopOpacity={0.4} />
              <stop offset="100%" stopColor={color} stopOpacity={0} />
            </linearGradient>
          </defs>
          <Tooltip
            cursor={{ stroke: "rgba(148,163,184,0.25)" }}
            contentStyle={{
              background: "hsl(222 47% 8%)",
              border: "1px solid hsl(217 32% 18%)",
              borderRadius: 6,
              fontSize: 12,
              padding: "4px 8px",
            }}
            labelStyle={{ color: "hsl(215 20% 65%)", fontSize: 11 }}
            itemStyle={{ color: "hsl(210 40% 98%)" }}
          />
          <Area
            type="monotone"
            dataKey="count"
            stroke={color}
            strokeWidth={1.5}
            fill={`url(#spark-${color})`}
            isAnimationActive={false}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
